var _rect, _line, _line2, _line3, _rect2, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShapefileDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 80,
    viewBox: "0 0 64 80",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 48,
    height: 64,
    rx: 4,
    ry: 4,
    fill: "white",
    stroke: "black",
    strokeWidth: 3
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 20,
    x2: 48,
    y2: 20,
    stroke: "black",
    strokeWidth: 2
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 28,
    x2: 48,
    y2: 28,
    stroke: "black",
    strokeWidth: 2
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 36,
    x2: 48,
    y2: 36,
    stroke: "black",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 50,
    width: 44,
    height: 20,
    rx: 2,
    ry: 2,
    fill: "black"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 32,
    y: 65,
    fontFamily: "Arial, sans-serif",
    fontSize: 14,
    fill: "white",
    fontWeight: "bold",
    textAnchor: "middle"
  }, "\r\n    SHP\r\n  ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShapefileDark);
export default __webpack_public_path__ + "static/media/shapefile_dark.8ed20f02587a6b5bcdd1d5639fd13242.svg";
export { ForwardRef as ReactComponent };